// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"setting_settingsContainer__gtjQ/"};